/* eslint-disable react/no-array-index-key */
import { IntlShape } from 'react-intl';
import { DisplayObject } from '../LayoutComponents/FieldArrayDisplay';

import { Goal } from '@amzn/aet-galactus-kit';
import { formatGoalToString } from '../../Goals/helper';

export const convertGoalsToDisplay = (
  goals: Goal[],
  intl: IntlShape
): DisplayObject[] => {
  const display: DisplayObject[] = [
    // Topic
    {
      label: intl.formatMessage({
        id: 'cs_perfportal_coaching_detail_label_readonly_attached_goals',
        defaultMessage: 'Attached Goals',
      }),
      value: '',
    },
  ];

  goals.map((goal, idx) => {
    display.push({
      label: `${intl.formatMessage({
        id: 'cs_perfportal_goal',
        defaultMessage: 'Goal',
      })} ${idx + 1}`,
      value: formatGoalToString(goal, intl),
    });
  });
  return display;
};
